export default "__VITE_ASSET__CxSO5MJo__"